module.exports = __webpack_public_path__ + "static/media/change-student.7c066caf.svg";